import get from 'lodash/get';

export const payerEvent = data => {
  return {
    payerName: get(data, 'payerName'),
    payerId: get(data, 'payerId'),
  };
};
